import { Injectable } from "@angular/core";
import { HttpService } from "../utils/http.service";
import { ICreditCardProcessPaymentResult, IPaymentModel } from "@models";

export interface INorthSISettingsModel {
	mid: string;
	developerKey: string;
	authPassword: string;
	appSource: string;
	accountId: string;
	email: string;
	environment: string;
}

export interface ITerminalProcessPaymentModel {
	customerId: number;
	invoiceId?: number;
	invoiceIds: number[];
	amount: number;
	invoiceNumber: string;
	poNumber: string;
	paymentReferenceCode: string;
	isOnlinePayment: boolean;
	isDownPayment: boolean;
	notes: string;
	includeCCFee: boolean;
}

@Injectable()
export class NorthSIService {
	constructor(private httpService: HttpService) { }

	async getNorthSISettings(companyId?: number): Promise<INorthSISettingsModel> {
		const params = companyId ? { companyId: companyId } : {};
		return await this.httpService.get("/northsi/getNorthSISettings", params);
	}

	async updateNorthSISettings(settings: INorthSISettingsModel): Promise<INorthSISettingsModel> {
		return await this.httpService.post("/northsi/updateNorthSISettings", settings);
	}

	async processTerminalPayment(terminalProcessPaymentModel: ITerminalProcessPaymentModel): Promise<ICreditCardProcessPaymentResult> {
		return await this.httpService.post("/northsi/processTerminalPayment", terminalProcessPaymentModel);
	}

	async refundPayment(paymentModel: IPaymentModel, amount: number): Promise<IPaymentModel> {
		return await this.httpService.post(`/northsi/refundPayment?amount=${amount}`, paymentModel);
	}

	async voidPayment(paymentModel: IPaymentModel): Promise<IPaymentModel> {
		return await this.httpService.post("/northsi/voidPayment", paymentModel);
	}

	/** Cancel a pending North push notification (e.g. when user clicks "Cancel waiting" in POS). */
	async cancelNotification(notificationId: string): Promise<void> {
		if (!notificationId) return;
		return await this.httpService.delete("/northsi/cancelNotification", { notificationId });
	}
}
